import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IOrganization } from '@interfaces/lookups';
import { handleGetOrganizations } from '@store/features/organizations/actions';
import {
  organizationsErrorSelector,
  organizationsIsLoadingSelector,
  organizationsIsReadySelector,
  organizationsSelector,
} from '@store/features/organizations/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useOrganizations = (): IOrganization[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(organizationsSelector);
  const isLoading = useSelector(organizationsIsLoadingSelector);
  const isReady = useSelector(organizationsIsReadySelector);
  const error = useSelector(organizationsErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetOrganizations());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.organizationsError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useOrganizations);
